import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { Box, Button, FocusLock, HStack, Image, Modal, ModalBody, ModalContent, ModalFooter, ModalOverlay, Text, VStack } from '@abb/uikit';
import { CheckCircle } from '@abb/uikit/icons/solid/general';
import { useGetTradePlatformStatus, useTradePlatformStatusMutation } from 'hooks';
import tradePlatformImage from 'images/trade-platform.png';
import React from 'react';
import { useTranslation } from 'react-i18next';
export function TradePlatformModal() {
    const { t } = useTranslation('common');
    const { data: isModalOpened, mutate } = useGetTradePlatformStatus();
    const { trigger, isMutating } = useTradePlatformStatusMutation({
        onSuccess: ()=>mutate()
    });
    return isModalOpened ? /*#__PURE__*/ _jsxs(Modal, {
        isOpen: true,
        onClose: ()=>{},
        size: "xl",
        isCentered: true,
        children: [
            /*#__PURE__*/ _jsx(ModalOverlay, {}),
            /*#__PURE__*/ _jsxs(ModalContent, {
                borderRadius: "24px",
                overflow: "hidden",
                maxWidth: "500px",
                children: [
                    /*#__PURE__*/ _jsxs(ModalBody, {
                        p: 0,
                        children: [
                            /*#__PURE__*/ _jsx(Image, {
                                alt: "trade-platform",
                                src: tradePlatformImage,
                                borderTopRadius: 6,
                                height: "250px"
                            }),
                            /*#__PURE__*/ _jsxs(VStack, {
                                alignItems: "flex-start",
                                gap: 2,
                                p: 6,
                                children: [
                                    /*#__PURE__*/ _jsx(Text, {
                                        fontSize: "24px",
                                        fontWeight: 600,
                                        lineHeight: "32px",
                                        children: t('trade-platform.popup-title')
                                    }),
                                    /*#__PURE__*/ _jsx(Text, {
                                        color: "semantic.onSurface.secondary",
                                        fontSize: "16px",
                                        lineHeight: "24px",
                                        children: t('trade-platform.popup-text')
                                    })
                                ]
                            })
                        ]
                    }),
                    /*#__PURE__*/ _jsxs(ModalFooter, {
                        gap: 3,
                        boxShadow: "none",
                        justifyContent: "space-between",
                        p: 6,
                        alignItems: "center",
                        children: [
                            /*#__PURE__*/ _jsx(Button, {
                                variant: "gray",
                                height: "48px",
                                backgroundColor: "semantic.surface.secondary",
                                py: 3,
                                borderRadius: "12px",
                                isDisabled: isMutating,
                                onClick: ()=>trigger('N'),
                                children: t('actions.close')
                            }),
                            /*#__PURE__*/ _jsxs(HStack, {
                                py: 2,
                                px: 4,
                                gap: 3,
                                backgroundColor: "semantic.container.success",
                                borderRadius: "16px",
                                children: [
                                    /*#__PURE__*/ _jsxs(VStack, {
                                        gap: 1,
                                        color: "semantic.source.success",
                                        children: [
                                            /*#__PURE__*/ _jsx(CheckCircle, {
                                                width: "16px",
                                                height: "16px"
                                            }),
                                            /*#__PURE__*/ _jsx(Box, {
                                                as: "span",
                                                fontSize: "13px",
                                                fontWeight: 600,
                                                lineHeight: "16px",
                                                children: t('trade-platform.free-of-charge')
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ _jsx(FocusLock, {
                                        children: /*#__PURE__*/ _jsx(Button, {
                                            isDisabled: isMutating,
                                            onClick: ()=>trigger('Y'),
                                            height: "48px",
                                            backgroundColor: "#1B63ED",
                                            py: 3,
                                            px: "37px",
                                            borderRadius: "12px",
                                            children: t('trade-platform.apply')
                                        })
                                    })
                                ]
                            })
                        ]
                    })
                ]
            })
        ]
    }) : null;
}
